import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { AssetWorkspaceFormPanel } from "@/features/assets/components/asset-workspace-form-panel";
import { assetInstanceQueryOptions } from "@/services/asset";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/assets/$assetId/workspace/form",
)({
	component: AssetWorkspaceFormTab,
});

function AssetWorkspaceFormTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/assets/$assetId/workspace/form",
	});
	const assetById = useQuery(
		assetInstanceQueryOptions.detail(params.assetId, {
			organizationId: params.orgId,
		}),
	);

	return (
		<AssetWorkspaceFormPanel
			asset={assetById.data}
			assetId={params.assetId}
			organizationId={params.orgId}
			isAssetPending={assetById.isPending}
		/>
	);
}
